var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Pi拍錢包付款說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用Pi拍錢包恕不適用分期付款。")]),_c('li',[_vm._v("付款額度限制：每筆交易上限為 10 萬。")]),_c('li',[_vm._v("Pi拍錢包付款有效時間：於訂單成立後 20 分鐘內，須完成付款。")])])])
}]

export { render, staticRenderFns }